"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const general_1 = require("../../assets/jss/general");
const styles = (theme) => (0, styles_1.createStyles)({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        minHeight: 48,
        borderRadius: 'inherit'
    },
    innerContainer: Object.assign(Object.assign({}, general_1.container), { display: 'flex', flexDirection: 'row' }),
    textSection: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        fontSize: 20
    },
    iconButton: {
        '&:focus': {
            backgroundColor: theme.palette.action.focus
        }
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing()
    },
    message: {
        display: 'flex',
        alignItems: 'center'
    },
    messageText: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(3)
    },
    close: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    link: {
        marginLeft: theme.spacing(),
        textDecoration: 'underline'
    },
    linkStatic: {
        marginLeft: theme.spacing(),
        border: '1px solid',
        borderRadius: 15,
        padding: '3px 15px'
    },
    titleText: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }
    }
});
exports.default = styles;
//# sourceMappingURL=MessageBarStyle.js.map